import React from 'react';
import { LineChart, Cpu, Lightbulb, Database } from 'lucide-react';

const focusAreas = [
  {
    icon: LineChart,
    title: 'Forecasting & Automation',
    description: 'Leverage sophisticated predictive models to stay ahead of market demands and automate critical workflows for maximum efficiency.',
  },
  {
    icon: Cpu,
    title: 'Digital Transformation',
    description: 'From legacy modernization to cloud migration, we guide organizations through a seamless, AI-driven shift toward greater agility and innovation.',
  },
  {
    icon: Lightbulb,
    title: 'AI Strategy & Implementation',
    description: 'We partner with you to design, develop, and deploy end-to-end AI solutions that align with your unique business goals.',
  },
  {
    icon: Database,
    title: 'Data-Driven Insights',
    description: 'Our data engineering and advanced analytics capabilities ensure you extract actionable intelligence from every data touchpoint.',
  },
];

const WhoWeAre = () => {
  return (
    <section className="py-20 bg-black">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 fade-in-up">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Who We Are & What We Do
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Agility is a strategic B2B AI consultancy and development firm, specializing in the convergence of advanced data engineering, predictive analytics, and transformative digital solutions. We empower enterprises to achieve sustainable growth and competitive advantage by leveraging cutting-edge AI, delivering future-ready solutions that drive efficiency, innovation, and measurable business outcomes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {focusAreas.map((area, index) => (
            <div
              key={index}
              className="bg-gray-900/50 backdrop-blur-sm rounded-xl p-8 shadow-lg hover:shadow-xl 
                transition-all duration-300 transform hover:-translate-y-1 border border-gray-800/50
                hover:bg-gray-900/70 card-hover fade-in-up"
            >
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-teal-500/10 rounded-xl flex items-center justify-center">
                    <area.icon size={24} className="text-teal-400" />
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white mb-3">{area.title}</h3>
                  <p className="text-gray-400 leading-relaxed">{area.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center fade-in-up">
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            At Agility, our mission is to empower businesses to adapt, scale, and thrive in 
            today's data-centric world one AI-driven solution at a time.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;